import type { PermissionsForRoles } from 'src/api/fm/permissions/permissions.model'
import { ADMIN_OWNER_ROLE_OPTIONS, OWNER_ROLE_OPTIONS } from 'src/pages/permissions/updateRoles/constants'

/** Role IDs from roleOptions with non-deprecated first, then those whose label contains "deprecated". */
export function getOrderedRoleIdsWithDeprecatedLast(roleOptions: Record<string, string>): string[] {
    const ids = Object.keys(roleOptions)
    const deprecated = ids.filter(id => roleOptions[id]?.toLowerCase().includes('deprecated'))
    const nonDeprecated = ids.filter(id => !roleOptions[id]?.toLowerCase().includes('deprecated'))
    return [...nonDeprecated, ...deprecated]
}

/** Same order as in Update user roles / Your permissions so table columns align with selectable roles. Deprecated roles last. */
export const ORDERED_SELECTABLE_ROLE_IDS = getOrderedRoleIdsWithDeprecatedLast(ADMIN_OWNER_ROLE_OPTIONS)

/**
 * Role IDs to show in the Roles info table: selectable roles first (same order as checkboxes),
 * then any roles from the API that are not in the selectable set.
 */
export function getOrderedRoleIdsForTable(userRolePermissions: PermissionsForRoles): string[] {
    const apiRoleIds = Object.keys(userRolePermissions)
    const selectableSet = new Set(ORDERED_SELECTABLE_ROLE_IDS)
    const apiOnlyIds = apiRoleIds.filter(id => !selectableSet.has(id))
    return [...ORDERED_SELECTABLE_ROLE_IDS, ...apiOnlyIds]
}

/** Human-readable label for a role ID. Use this so role names match across Permissions page (table vs checkboxes). */
export const getRoleDisplayName = (roleId: string): string => ADMIN_OWNER_ROLE_OPTIONS[roleId] ?? roleId

export const getStringifiedOwnerRoles = (roles: string[] | undefined): string => {
    if (!roles) {
        return ''
    }

    return roles
        .map(role => OWNER_ROLE_OPTIONS[role])
        .filter(Boolean)
        .join(', ')
}

export const getStringifiedAdminOwnerRoles = (roles: string[]): string => {
    if (!roles) {
        return ''
    }

    return roles
        .map(role => ADMIN_OWNER_ROLE_OPTIONS[role])
        .filter(Boolean)
        .join(', ')
}
